import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import LmHeader from '../components/LmHeader.jsx';
import LmFooter from '../components/LmFooter.jsx';

const { TextArea } = Input;

const Register = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await axios.post('https://limitverify.ru:5000/api/auth/register', {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        phone: values.phone || null,
        password: values.password,
        comment: values.comment || null
      });

      message.success('Регистрация успешна!');

      // Сохраняем токен в localStorage
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));

      // Перенаправляем на dashboard
      navigate('/dashboard');

    } catch (error) {
      console.error('Registration error:', error);
      if (error.response?.data?.error) {
        message.error(error.response.data.error);
      } else {
        message.error('Ошибка при регистрации. Попробуйте еще раз.');
      }
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
    message.error('Пожалуйста, заполните все обязательные поля.');
  };

  return (
    <div className="lm-page">
      <LmHeader actions={[{ label: 'Вход', onClick: () => navigate('/login') }]} />

      <main className="lm-content lm-content--center">
        <div className="lm-auth">
          <div className="lm-auth__head">
            <h1 className="lm-auth__title">Регистрация</h1>
            <span className="lm-auth__sub">Создайте аккаунт для доступа к системе</span>
          </div>

          <Form
            form={form}
            name="register"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            layout="vertical"
            requiredMark={false}
            className="lm-auth__form"
          >
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <Form.Item
                name="firstName"
                label="Имя"
                style={{ marginBottom: 0, flex: 1, minWidth: 140 }}
                rules={[{ required: true, message: 'Пожалуйста, введите имя!' }]}
              >
                <Input placeholder="Имя" />
              </Form.Item>

              <Form.Item
                name="lastName"
                label="Фамилия"
                style={{ marginBottom: 0, flex: 1, minWidth: 140 }}
                rules={[{ required: true, message: 'Пожалуйста, введите фамилию!' }]}
              >
                <Input placeholder="Фамилия" />
              </Form.Item>
            </div>

            <Form.Item
              name="email"
              label="Email"
              style={{ marginBottom: 0 }}
              rules={[
                { required: true, message: 'Пожалуйста, введите email!' },
                { type: 'email', message: 'Пожалуйста, введите корректный email!' }
              ]}
            >
              <Input placeholder="email@example.com" />
            </Form.Item>

            <Form.Item name="phone" label="Телефон" style={{ marginBottom: 0 }}>
              <Input placeholder="+7 (999) 123-45-67" />
            </Form.Item>

            <Form.Item
              name="password"
              label="Пароль"
              style={{ marginBottom: 0 }}
              rules={[
                { required: true, message: 'Пожалуйста, введите пароль!' },
                { min: 8, message: 'Пароль должен содержать минимум 8 символов!' }
              ]}
            >
              <Input.Password placeholder="Минимум 8 символов" />
            </Form.Item>

            <Form.Item
              name="confirmPassword"
              label="Подтвердите пароль"
              dependencies={['password']}
              style={{ marginBottom: 0 }}
              rules={[
                { required: true, message: 'Пожалуйста, подтвердите пароль!' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Пароли не совпадают!'));
                  },
                }),
              ]}
            >
              <Input.Password placeholder="Повторите пароль" />
            </Form.Item>

            <Form.Item name="comment" label="Комментарий" style={{ marginBottom: 0 }}>
              <TextArea rows={3} placeholder="Дополнительная информация (опционально)" />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button htmlType="submit" loading={loading} block style={{ textTransform: 'uppercase' }}>
                Зарегистрироваться
              </Button>
            </Form.Item>
          </Form>

          <div className="lm-auth__row">
            <span className="lm-link">Уже есть аккаунт?</span>
            <button
              type="button"
              className="lm-link lm-link--light"
              onClick={() => navigate('/login')}
            >
              Войти в систему
            </button>
          </div>
        </div>
      </main>

      <LmFooter />
    </div>
  );
};

export default Register;
